export const GET_SCHEDULE_OTP_CODE_API_ENDPOINT = '/booking-portal/OTP/GetOTPBookExperience';
